(function(){
		console.log("*");
  		const el = $('#stick-nav');
  		document.addEventListener('scroll', function(e) {
          	var scroll = Math.round(window.scrollY);
          	var offset = Math.round(el.offset().top);
          if(scroll >= offset){
            el.css({"position": 'fixed' , "top": '0' , "left": '0'});
            el.addClass('fixed-nav');
          }else if(scroll == 0){
            el.css({"position": 'relative' , "top": '0' });
            el.removeClass('fixed-nav');
          }	
    	});
	})();

